import React from 'react'
import { useTranslation } from 'react-i18next'

export const useApplicationName = () => {
  const { t } = useTranslation()
  return React.useMemo(() => {
    const location = window.location.href
    const fr = /carcat/gi
    const appName = fr.test(location) ? t('shop.carcat') : t('shop.module_gms')
    return { appName }
  }, [window.location.href])
}
